<div class="row">
  <div class="col-md-4">
    <div class="row pb-2">
      <div class="col-6 font-weight-bold">{{'global.status'|translate}}</div>
      <div class="col-6">{{request.reply.replyItems[Index].replyChangeStatus.status.translationKey|translate}}</div>
    </div>
  </div>
</div>
